export interface SampleDetailInSampleActivity {
    indskr_skuid: string;
    indskr_skuname: string;
    deleted?: boolean;
    indskr_customersampleproductid?: string;
    indskr_quantity?: number;
    lotsCount?: number;
    totalQuantity?: number;
    customersample_statecode?:number;
    sku_statecode?:number;
    brand_statecode?:number;
    indskr_customersamplevalidfromdate?:string;
    indskr_customersamplevalidtodate?:string;
    isInvalid?:boolean;
    indskr_isunlimited? : boolean;
    indskr_esignaturenecessaryflag? : boolean
    samplelimitpervisit? : number;
    currencySymbol: string;
    allocationRulesProfileId?:string;
    lots:Array<LotDetailInSampleActivity>
}

// OMNI-61611: raw brand product from the brandskuproducts endpoint. Banners are
// per-brand (producttype 100000002); child SKUs carry the ids used on samples.
export interface BrandSkuProductDTO {
    productid: string;
    name?: string;
    producttype?: number;
    indskr_productimageurl?: string;
    skus?: Array<{ productid: string; name?: string }>;
}

// OMNI-61611: per-brand banner, keyed by brand product id, with offline state.
export interface OfflineProductBanner {
    productId: string;          // brand product id (storage / download key)
    brandName: string;          // brand name, used to resolve the config bannerKey
    bannerUrl: string;          // remote image url (indskr_productimageurl)
    fileName: string;           // local file name under /product-banners/<productId>
    skuIds: string[];           // child SKU ids, to map a sampled SKU -> this brand
    downloaded: boolean;        // true once the image is on device
    downloadDate?: number;
}

export interface LotDetailInSampleActivity {
    indskr_quantity: number;
    indskr_lotid: string;
    indskr_lotname?: string;
    indskr_lotvalidtodate?: string;
    indskr_lotvalidfromdate?:string;
    indskr_lotnumber? : string;
    formattedDate?: Date;
    deleted?: boolean;
    statecode?:number;
    indskr_unitprice?: number;
    indskr_totalsamplevalue?: number;
    formattedValidToDate?: string;
    indskr_lastdispatchdate?: string;
    formattedLastDispatchDate?: string;
    isLastDispatchDate?: boolean;
    indskr_iscontrolled?: boolean;
    // OMNI-62549: transport-only hint telling the backend this drop may take the lot's on-hand below
    // zero (lot was in the rep's last physical count). Not a CRM field.
    allowNegativeOnHand?: boolean;
}

export interface PouchDbDoc {
    _id?: string;
    _rev?: string;
    lastUpdatedTime?: number;
}

export interface CustomerSampleAllocationDTO extends PouchDbDoc {
    indskr_customersampleproductid: string;
    indskr_skuid:string;
    indskr_skuname: string;
    indskr_contactid: string;
    indskr_contactname: string;
    indskr_startdate: string;
    indskr_enddate: string;
    indskr_eligibilitylimit: number;
    indskr_totalsamplesdropped: number;
    indskr_totalsamplesremaining: number;
    track_action?: number;
    modifiedon?: string;
    indskr_isunlimited: boolean;
    samplelimitpervisit? : number;
    indskr_totalsamplevaluedelivered: number;
    totalsamplevaluelimit: number;
    currencySymbol: string;
    allowvaluelimitunblock: boolean;
    skuUnitPrice: number;
    buProductSampling: boolean;
    allocationName: string;
    buId: string;
    buName: string;
    skuCurrencyId?: string;
    allocCurrencyId?: string;
    allocationRulesProfileId?: string;
}
export interface SampleAllocationDTO extends PouchDbDoc {
    indskr_productid: string;
    indskr_skuid: string;
    indskr_skuname: string;
    indskr_startdate: string;
    indskr_enddate: string;
    statecode: number;
    statuscode: number;
}

export interface LotDTO extends PouchDbDoc {
    indskr_lotid: string;
    name: string;
    indskr_lotnumber: string;
    indskr_skuid: string;
    indskr_skuname: string;
    indskr_lotvalidfromdate: string;
    indskr_lotvalidtodate: string;
    statecode: number;
    indskr_totalquantitydropped?: number;
    indskr_totalquantityrecieved?: number;
    indskr_totalquantityremaining?: number;
    indskr_unitprice?: number;
    indskr_totalsamplevalue?: number;
    indskr_lastdispatchdate?: string;
    indskr_iscontrolled?: boolean;
}

export interface SampleActivityDTO extends PouchDbDoc {
    activityid: string;
    subject: string;
    activitytypecode?: string;
    statecode: number;
    statuscode: number;
    scheduledstart: string;
    scheduledend: string;
    indskr_appintmentid: string;
    scheduleddurationminutes?: string;
    actualstart: string;
    actualend: string;
    indskr_contactid: string;
    indskr_signature: string;
    indskr_contactname?: string;
    indskr_customeraddress: string;
    location: string;
    indskr_ownerid: string;
    indskr_ownerfullname: string;
    activitySampleDrops: Array<SampleDetailInSampleActivity>
    indskr_orderid: string;
    track_action?: number;
}

export interface ValidatedCustomerLicense {
    id: string;
    typeLabel: string;
    licenseNumber: string;
    customerAllocId: string;
}
